import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppPages } from '@constants/app-pages';
import { GetApiSecundariaRepository } from '@data/repository/home/getApiSecundarias.repository';
import { environment } from '@environment/environment';
import { ReservaService } from '@infra/reserva/reserva.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiSecundariaController } from '@presentation/controllers/api-secundaria-controller/api-secundaria.controller';
import { ReservaController } from '@presentation/controllers/reserva/reserva.controller';
import { NotificationService, NotificationStyle } from '@presentation/view/shared/notification/notification.service';
import { Stripe, StripeElements, loadStripe } from '@stripe/stripe-js';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  stripe!: Stripe;
  elements!: StripeElements;
  cardElement: any;
  isLoading: boolean = false;
  name = '';
  email = '';
  currency = 'brl';
  amount = 0;
  currentLanguage;
  dataSummary;
  payloadReservas;
  endpointStripe;
  quantidadeHorasExtras: number = 0;
  valorHoraExtra: number = 0;
  valorTotalHoraExtras: number = 0;
  customCurrencyDefault: string;
  habilitarRedirecionamentoIMOB: boolean = false;
  taxas;


  constructor(private http: HttpClient, private notification: NotificationService, public translateService: TranslateService, private controllerReserva: ReservaController, private reservaService: ReservaService, private router: Router, private getApiSegundariasRepository: GetApiSecundariaRepository, private apiSecundariaController: ApiSecundariaController) {

    this.currentLanguage = localStorage.getItem('language')
    this.customCurrencyDefault = sessionStorage.getItem('customCurrencyDefault')
    this.habilitarRedirecionamentoIMOB = sessionStorage.getItem('habilitarRedirecionamentoIMOB') == 'S'
    this.taxas = this.reservaService.taxasData
  }

  async ngOnInit() {
    this.getApiSecundarias()
    const reservaPayload = sessionStorage.getItem('reservaPostPayload')
    const storedAmount = sessionStorage.getItem('totalPriceDiscount') ? sessionStorage.getItem('totalPriceDiscount') : sessionStorage.getItem('totalPrice');
    const summaryData = sessionStorage.getItem('summaryDataPayment');
    const pagamentoStripe = sessionStorage.getItem('pagamentoStripe')

    if (pagamentoStripe != 'S' || !summaryData || !reservaPayload) {
      this.router.navigateByUrl(AppPages.HOME);
    }

    if (summaryData) {
      this.dataSummary = JSON.parse(summaryData);
    }

    if (reservaPayload) {
      this.payloadReservas = JSON.parse(reservaPayload)
    }

    if (storedAmount) {
      const parsedAmount = parseFloat(storedAmount);
      this.amount = parseFloat(parsedAmount.toFixed(2));
    }

    this.name = this.payloadReservas?.Cliente?.RazaoSocial
    this.email = this.payloadReservas?.Cliente?.Email
    this.currency = this.currentLanguage == 'en-US' ? 'usd' : 'brl'
    this.stripe = await loadStripe(`${environment.stripeKey}`);
    this.elements = this.stripe.elements();

    const style = {
      base: {
        color: '#32325d',
        fontSize: '16px',
        fontFamily: '"Segoe UI", Helvetica, sans-serif',
        '::placeholder': {
          color: '#a0aec0',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };

    this.cardElement = this.elements.create('card', { style });
    this.cardElement.mount('#card-element');

    let horasExtrasData = JSON.parse(sessionStorage.getItem('extraHours'));
    this.quantidadeHorasExtras = horasExtrasData?.quantidadeHorasExtras || 0;
    this.valorHoraExtra = horasExtrasData?.valorHoraExtra || 0;
    this.valorTotalHoraExtras = horasExtrasData?.valorTotalHoraExtras || 0;
  }

  async pay() {
    Swal.fire({
      title: this.translateService.instant('PROCESSING_PAYMENT_TITLE'),
      html: this.translateService.instant('PROCESSING_PAYMENT_TEXT'),
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const { error, paymentMethod } = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.cardElement,
      billing_details: {
        name: this.name,
        email: this.email,
      }
    });

    if (error) {
      Swal.close(); // Fecha o loading
      Swal.fire('Erro', error.message || 'Erro ao processar pagamento', 'error');
      return;
    }

    try {
      const response: any = await this.http.post(`${this.endpointStripe + 'pagamentos/payment-intent-create'}`, {
        amount: this.arredondarMoeda(this.amount), // centavos
        currency: this.currency,
        payment_method: paymentMethod.id,
        receipt_email: this.email,
        description: `${this.translateService.instant('DESCRIPTION_RESERVATION')} - ${this.name}`
      }).toPromise();

      const ClientSecret = response?.data?.ClientSecret;
      const result = await this.stripe.confirmCardPayment(ClientSecret);

      Swal.close(); // Fecha o loading antes de mostrar o resultado final

      if (result.error) {
        Swal.fire('Erro', result.error.message, 'error');
      } else if (result.paymentIntent.status === 'succeeded') {
        Swal.fire({
          icon: 'success',
          title: this.translateService.instant('PAYMENT_SUCCESS_TITLE'),
          text: this.translateService.instant('PAYMENT_SUCCESS_TEXT'),
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(() => {
          this.postReservas({ payment_intent: result.paymentIntent.id });
        });
      }
    } catch (err: any) {
      Swal.close();
      Swal.fire('Erro', err.message, 'error');
    }
  }

  postReservas(paymentIntentId) {
    if (this.payloadReservas) {
      Swal.fire({
        title: this.translateService.instant('PROCESSING_RESERVATION_TITLE'),
        html: this.translateService.instant('PROCESSING_RESERVATION_TEXT'),
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.controllerReserva.insert(this.payloadReservas).subscribe({
        next: (value: any) => {
          Swal.close();
          this.isLoading = false;
          this.notification.showSnack(
            this.translateService.instant('TXT_DONE_RESERVATION'),
            NotificationStyle.SUCCESS
          );
          if (this.habilitarRedirecionamentoIMOB && value?.Data?.LinkIturanMob) {
            sessionStorage.setItem('linkImob', value?.Data?.LinkIturanMob)
          }
          this.reservaService.clear();

          this.router.navigateByUrl(AppPages.SUCCESS, {
            state: { CodigoReserva: value.Data.CodigoReserva },
          });
        },
        error: async (err: any) => {
          Swal.close();
          this.isLoading = false;

          // Mostra o popup informando que houve erro e que o estorno está em andamento
          Swal.fire({
            icon: 'error',
            title: this.translateService.instant('RESERVATION_ERROR_TITLE'),
            html: this.translateService.instant('RESERVATION_ERROR_REFUND_PROCESSING'),
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
              this.http.post(`${this.endpointStripe + 'pagamentos/payment-intent-refund'}`, paymentIntentId).toPromise().then(() => {
                // Aguarda 3 segundos antes de mostrar o resultado
                setTimeout(() => {
                  Swal.fire({
                    icon: 'success',
                    title: this.translateService.instant('RESERVATION_ERROR_REFUND_TITLE_SUCCESS'),
                    text: this.translateService.instant('RESERVATION_ERROR_REFUND_SUCCESS'),
                    confirmButtonText: this.translateService.instant('BTN_OK'),
                    allowOutsideClick: false,
                  });
                }, 3000);
              })
                .catch(() => {
                  // Aguarda 3 segundos mesmo se o reembolso falhar
                  setTimeout(() => {
                    Swal.fire({
                      icon: 'warning',
                      title: this.translateService.instant('RESERVATION_ERROR_TITLE_FAILED'),
                      text: this.translateService.instant('RESERVATION_ERROR_REFUND_FAILED'),
                      confirmButtonText: this.translateService.instant('BTN_OK'),
                      allowOutsideClick: false,
                    });
                  }, 3000);
                });
            }
          });
        }
      });
    }
  }


  public getApiSecundarias() {
    this.getApiSegundariasRepository.getApiSecundariaId().subscribe({
      next: (response) => {
        const items = response?.Data?.items || [];
        const apiStripe = items.find(api => api.Descricao === 'Api Stripe');
        if (!apiStripe) {
          return;
        }

        this.apiSecundariaController.getApiSecundaria().subscribe({
          next: (data: any) => {
            const resultado = data?.Data?.items?.find(
              (item) => {
                return item.CodigoApiSecundaria == apiStripe.CodigoApiSecundaria
              }
            );
            if (resultado) {
              this.endpointStripe = resultado.Endpoint.toString()
            }
          },
          error: (err) => {
            console.error('Erro ao obter Api Secundária:', err);
          }
        });
      },
      error: (error) => {
      },
    });
  }

  private arredondarMoeda(valor: number): number {
    return Math.round((valor + Number.EPSILON) * 100);
  }
}